var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prompts"},[_c('div',{staticClass:"prompts-item"},[_c('img',{staticClass:"roster-clear-img",attrs:{"src":require("./plaint.svg"),"alt":""}}),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"prompts-item1"},[_vm._t("two")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-691c9292","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prompts/index.vue
// module id = null
// module chunks = 